export default function Label({children}){
    return (
        <label className="block text-xs text-primary font-medium mb-1.5 uppercase">
            { children }
        </label>
    );
}